import { create } from "zustand";
import { storage } from "../utils/Storage";
import { persist } from "zustand/middleware";

const useLng = create(
  persist(
    (set) => ({
      toggle: false,
      lng: "id",
      lngList: ["id", "en"],
      setToggle: () => set((state) => ({ ...state, toggle: !state.toggle })),
      setLanguage: (lng) => set((state) => ({ ...state, toggle: false, lng })),
    }),
    { name: "LNG", storage: storage, partialize: (state) => ({ lng: state.lng }) }
  )
);

export default useLng;
